/** External site links (open in a new tab). Keep public/landing/index.html in sync. */
export const siteLinks = {
  contact: "http://go.requirementone.com/contact",
  support: "http://go.requirementone.com/support",
  privacy: "http://go.requirementone.com/legal-privacy",
  terms: "http://go.requirementone.com/legal-terms-conditions",
  legal: "http://go.requirementone.com/legal",
  cookies: "http://go.requirementone.com/legal-cookies",
  dpa: "http://go.requirementone.com/legal-dpa",
  companyWebsite: "http://go.requirementone.com/website",
  sales: "http://go.requirementone.com/sales",
} as const;

export const externalLinkProps = {
  target: "_blank",
  rel: "noopener noreferrer",
} as const;

/** Customer-facing trust and privacy copy. Keep public/landing/index.html in sync. */
export const trustCopy = {
  infrastructureBadge: "Private infrastructure · European datacenter",

  privacyStatement:
    "Your documents are processed privately in our infrastructure, in a European Microsoft datacenter. We use them only to generate your report. Your data is not used for model training.",

  documentHandlingFaq:
    "Your documents are processed privately in our infrastructure, in a European Microsoft datacenter. We use them only to generate your report. Your data is not used for model training.",

  uploadHelp: "Uploaded to our private infrastructure. Used only for your report.",

  privacyHeading: "Private by design.",

  startBullets: [
    "No account required",
    "Processed privately in our infrastructure (European Microsoft datacenter)",
    "Your data is not used for model training",
    "Free preview emailed to you",
    "Pay only to upgrade to the full deliverable (Word + Excel)",
  ] as const,

  auditTrailChat: "No structured audit trail",
  auditTrailWin: "Structured findings with a reproducible run log",
} as const;
